import React from 'react'
import { css } from 'react-emotion';
import { FadeLoader } from 'react-spinners';
import { colorPalette } from "mixins/colorful"

const override = css`
  margin: 0 auto;
`;

class Spinner extends React.Component {
  render() {
    const {
      message,
    } = this.props;

    return(
      <div className='spinner-container'>
        <div className='spinner-block'>
          <FadeLoader
            className={ override }
            sizeUnit={"px"}
            size={ 200 }
            color={ colorPalette('white') }
            loading={ true }
            height={ 11 }
            width={ 11 }
            radius={ 11 }
          />
          <div>
            { message }
          </div>
        </div>
      </div>
    )
  }
}

export default Spinner;
